<template lang="pug">
  .store-tour
    .store-tour__media
      iframe.store-tour__tour(
        v-if="displayTour"
        src="https://www.google.com/maps/embed?pb=!1m0!3m2!1sen!2sus!4v1425247323636!6m8!1m7!1sVnl8zXybIIAAAAQY_PzJDA!2m2!1d34.135358!2d-116.316515!3f199.72!4f-14.950000000000003!5f0.7820865974627469"
        frameborder="0"
        style="border: 0;"
      )
      img.store-tour__image(
        v-else
        :src="tourImage"
      )
    .store-tour__content.container
      slot
      primary-button.store-tour__cta(
        v-if="haveTourImage"
        @click="toggleTour"
        :secondary="isSecondary"
        :label="buttonText"
      )
</template>

<script>
  import PrimaryButton from 'scripts/components/buttons/PrimaryButton.vue';

  export default {
    name: "StoreTour",
    components: { PrimaryButton },
    props: {
      tourImage: String,
      buttonType: String,
    },
    data() {
      return {
        tourVisible: false,
      };
    },
    computed: {
      haveTourImage() {
        return this.tourImage;
      },
      displayTour() {
        if (!this.tourImage) return true;
        return this.tourVisible;
      },
      isSecondary() {
        return this.buttonType === 'secondary';
      },
      buttonText() {
        if (this.displayTour) {
          return 'Close Tour';
        } else {
          return 'Take Virtual Tour';
        }
      }
    },
    methods: {
      toggleTour() {
        this.tourVisible = !this.tourVisible;
      }
    },
  };
</script>

<style lang="scss" scoped>
  .store-tour {
    margin: $grid-gutter auto;
    max-width: 1380px;
    display: flex;
    flex-direction: column;

    @include tablet-up() {
      flex-direction: row;
      align-items: center;
    }
  }

  .store-tour__media,
  .store-tour__content {
    flex-basis: 50%;
    flex-grow: 0;
    flex-shrink: 0;
  }

  .store-tour__image,
  .store-tour__tour {
    display: block;
  }

  .store-tour__tour {
    width: 100%;
    height: 615px;
  }

  .store-tour__content {
    max-width: 480px;
    text-align: center;

    @include desktop-up {
      text-align: left;
    }
  }

  .store-tour__title {
    margin-top: 16px;
    margin-bottom: 16px;
    color: $color-indigo;

    @include desktop-up {
      margin-top: 0;
    }
  }

  .store-tour__cta {
    margin-top: 16px;
  }
</style>
